__turbopack_context__.v({
  "daysOfRainHeading": "o2GeKG_daysOfRainHeading",
  "root": "o2GeKG_root",
  "temperatureSection": "o2GeKG_temperatureSection",
  "waterTemperatureHeading": "o2GeKG_waterTemperatureHeading",
});
